// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M6.75 4.33594L14.4142 12.0002L6.75 19.6644V4.33594ZM17.5 5.00015V19.0002H15.5V5.00015H17.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-next-filled')
export default class NextFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'next-filled',
    }
  }
}
